/*
 * @Author: xxx xxx
 * @Date: 2022-12-28 16:38:14
 * @LastEditors: xxx xxx
 * @LastEditTime: 2023-02-13 17:44:25
 * @FilePath: \react-admin\src\App.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { ConfigProvider, theme } from "antd";
import { connect } from "react-redux";
import { setLanguage } from "@/redux/modules/global/action";
import { BrowserRouter } from "react-router-dom";
import AuthRouter from "@/routers/utils/authRouter";
import Router from "@/routers/index";
import zhCN from "antd/locale/zh_CN";
const App = () => {
	return (
		<BrowserRouter>
			<ConfigProvider
				locale={zhCN}
				theme={{
					components: {
						Card: {
							/* 这里是你的组件 token */
						}
					},
					token: {
						colorPrimary: "#005eb8"
					}
				}}
			>
				<AuthRouter>
					<Router />
				</AuthRouter>
			</ConfigProvider>
		</BrowserRouter>
	);
};

const mapStateToProps = (state: any) => state.global;
const mapDispatchToProps = { setLanguage };
export default connect(mapStateToProps, mapDispatchToProps)(App);
